import {getAdjustedCdnUrl} from '@aboutyou/utils';
import {styled} from '@linaria/react';
import React from 'react';
import {COLORS} from '../../../constants/colors';
import {FONT_WEIGHTS} from '../../../constants/typography';
import {ImageType} from '../../../types/Image';
import {Image} from '../../atoms/Image/Image';
import {Text} from '../../atoms/Text/Text';
import {UnstyledLinkLinaria} from '../../atoms/UnstyledLink/UnstyledLinkLinaria';

interface UspProps {
  className?: string;
  href?: string;
  image?: ImageType;
  text: string;
}

export const Usp: React.FC<UspProps> = ({className, href, image, text}) => {
  return (
    <ConditionalLinkWrapper
      data-testid="UspContainer"
      href={href}
      className={className}
    >
      {image && (
        <UspImage
          data-testid={'UspIcon'}
          src={getAdjustedCdnUrl(image.url, {
            trim: true,
          })}
          alt={image.description}
          breakpoints={[]}
          widths={[50]}
          ratio={'1:1'}
          loading="lazy"
        />
      )}
      <UspText data-testid={'UspText'} color="inherit" size="px12">
        {text}
      </UspText>
    </ConditionalLinkWrapper>
  );
};

const ConditionalLinkWrapper: React.FC<
  React.PropsWithChildren<Partial<UspProps> & {['data-testid']?: string}>
> = ({children, 'data-testid': dataTestId, href, ...rest}) => {
  if (href) {
    return (
      <UspItemLink
        aria-label={undefined}
        data-testid={dataTestId}
        to={href}
        {...rest}
      >
        {children}
      </UspItemLink>
    );
  }

  return (
    <UspItem data-testid={dataTestId} {...rest}>
      {children}
    </UspItem>
  );
};

const UspText = styled(Text)`
  margin-left: 10px;
  hyphens: auto;
  line-clamp: 2;
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
  color: ${COLORS.Black};
`;

const UspImage = styled(Image)`
  box-sizing: border-box;
  height: 16px;
  width: 16px;
  object-fit: contain;
  position: relative;
  top: 1px;
  margin-right: 2px;
`;

const uspItemStyles = `
  display: flex;
  align-items: center;
  flex-basis: 50%;
  flex-grow: 0;
  flex-shrink: 1;
  box-sizing: border-box;
  min-width: 0;
  padding: 4px 0;
`;

const UspItem = styled.div`
  ${uspItemStyles};
`;

const UspItemLink = styled(UnstyledLinkLinaria)`
  ${uspItemStyles};
`;
